/**
 * Create Bundle
 */

// React
import React, { FunctionComponent, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import theme from '../../theme';
// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import {
  getOrdersAction,
  updateOrderStatusActions,
  updateAllOrderStatusActions,
  cancelOrderAction,
  getAllOrdersReportAction,
  changeDeliveryTypeAction,
} from '../orders/actions';
import { Store } from '../../redux/reducers';
import { GetAllVehiclesRequestBuilder } from 'client-sdk/src/vehicles/vehicles';
import { cleanDriverListAction, getDriversAction } from '../drivers/actions';

// Selector
import { createStructuredSelector } from 'reselect';
import {
  makeSelectOrdersList,
  makeSelectLoading,
  makeSelectError,
  makeSelectCountList,
  makeSelectAllOrders,
} from '../orders/selectors';

import {
  makeSelectLoading as makeDriverLoading,
  makeSelectDriversList,
} from '../drivers/selectors';

// UI
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputBase,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  ClickAwayListener,
  InputLabel,
  FormHelperText,
  TextField,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import {
  MuiPickersUtilsProvider,
  DatePicker,
  TimePicker,
} from '@material-ui/pickers';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPackageVariant,
  mdiStateMachine,
  mdiCalendar,
  mdiMagnify,
  mdiWarehouse,
  mdiArrowRight,
  mdiClose,
  mdiTruckDeliveryOutline,
  mdiMapMarkerCheckOutline,
  mdiCar,
  mdiKeyOutline,
  mdiCityVariantOutline,
  mdiCity,
} from '@mdi/js';

// Components
import Client from 'client-sdk/src/client';
import RenderFilter from '../../utils/listDaynamicFilter';
import type { Filter } from '../../utils/listDaynamicFilter';
import List from './list';
import Pagination from '@material-ui/lab/Pagination';
import OrderedList from './orderedlist';

// Helper
import {
  convertPersianDigit2English,
  removeEmptyValueObject,
} from '../../utils/helpers';
import jMoment from 'moment-jalaali';
import JalaliUtils from '@date-io/jalaali';

// Type
import {
  Payload,
  cancelPayload,
  PayloadAllUpdate,
  PayloadChangeDeliveryType,
  Order,
} from '../orders/interfaces';
import { SelectorProps, Props } from './interfaces';
import handleError from '../../utils/handleError';
import { CreateBundleRequestBuilder } from 'client-sdk/src/bundles/bundle';
import handleNotfication from '../../utils/handleNotification';

type Inputs = {
  'customerNationalCode.contains': string;
};

interface driverInputs {
  vehicleType: string;
  driverName: string;
  driverId: number | string;
  deliveryDate: string;
  deliveryStartTime: string;
  deliveryEndTime: string;
  deliveryTime: string;
  bundleName: string;
}

jMoment.loadPersian({ dialect: 'persian-modern', usePersianDigits: true });
// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    paper: {},
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    inputHolder: {
      flex: 1,
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
      width: '100%',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '18px',
      textAlign: 'center',
      fontWeight: 500,
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(2),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    btnBox: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },

    typeSection: {
      textAlign: 'center',
      marginBottom: theme.spacing(2),
    },
  })
);

const CreateBundle: FunctionComponent<Props> = (props: Props) => {
  const token = localStorage.getItem('token') || '';
  const {
    register,
    handleSubmit,
    reset,
    errors,
    setValue,
    control,
    getValues,
  } = useForm<Inputs | driverInputs>();
  const {
    // register:secondRegister,
    handleSubmit: handleSubmitHandler,
    // reset:secondReset,
    errors: secondError,
    setValue: secondSetValue,
    control: secondControl,
    getValues: secondGetValue,
  } = useForm<Inputs | driverInputs>({
    defaultValues: {
      deliveryDate: new Date()
    }
  });
  const [filters, setFilters] = useState([] as Filter[]);
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 10,
  } as any);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openFilterBox, setOpenFilterBox] = React.useState(false);
  const [showDragList, setShowDragList] = useState(false as boolean);
  const [selectedList, setSelectedList] = useState([] as Order[]);
  const [selectDriver, setSelectDriver] = useState(false as boolean);
  const [confirmationDialog, setConfirmationDialog] = useState(
    false as boolean
  );
  const [bundleInfo, setBundleInfo] = useState<driverInputs | null>(null);
  const [loading, setLoading] = useState(false as boolean);
  const [numSelected, setNumSelected] = useState(0);
  const [bundleType, setBundleType] = useState("");
  const [searchId, setSearchId] = useState(null)

  useEffect(() => {
    if (props.ordersList.length == 1 && searchId == props.ordersList[0].id) {
      handleSelectItem(props.ordersList[0])
    }
  }, [props.ordersList])


  const handleClick = () => {
    setOpenFilterBox(prev => !prev);
  };

  const handleOpenSelectDriver = (data: driverInputs, type: string) => {
    setBundleType(type)
    setSelectedList(data);
    setSelectDriver(true);
  };

  const handleCloseSelectDriver = () => {
    setSelectDriver(false);
  };

  const onSubmit = (filtervalues: any) => {
    setFiltersValues({
      ...removeEmptyValueObject(filtervalues),
      page: 0,
      size: 10,
    });
    setSearchId(filtervalues.id.equals)
    reset({});
    setOpenFilterBox(false);
  };

  const handleSelectList = (selected: Order[]) => {
    console.log(selected)
    setShowDragList(true);
  };
  const handleSelectItem = (order: any) => {
    const selectedIndex = selectedList.map(el => el.id).indexOf(
      order.id
    );
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(
        selectedList,
        props.ordersList.find((el: Order) => el.id === +order.id)
      );
      setSelectedList(newSelected);
      setNumSelected(newSelected.length)
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedList.slice(1));
      setSelectedList(newSelected);
      setNumSelected(newSelected.length)
    } else if (selectedIndex === selectedList.length - 1) {
      newSelected = newSelected.concat(selectedList.slice(0, -1));
      setSelectedList(newSelected);
      setNumSelected(newSelected.length)
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedList.slice(0, selectedIndex),
        selectedList.slice(selectedIndex + 1)
      );
      setSelectedList(newSelected);
      setNumSelected(newSelected.length)
    }
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.ordersList;
      setSelectedList(newSelecteds);
      setNumSelected(newSelecteds.length)

      return;
    }
    setSelectedList([]);
    setNumSelected(0)
  };

  useEffect(() => {
    getOrders();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getOrders = () => {
    const { page, size } = filtersValues;
    props.ordersDispatch({
      ...filtersValues,
      deliveryType: { notEquals: 'POST' },
      page,
      size,
    });
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'customerCity.contains',
        label: 'شهر',
        icon: mdiCityVariantOutline,
      },
      {
        type: 'input',
        id: 'customerName.contains',
        label: 'نام سفارش‌دهنده',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه سفارش',
        icon: mdiPackageVariant,
      },
      {
        type: 'input',
        id: 'partnerName.contains',
        label: 'شرکت',
        icon: mdiCity,
      },
      {
        type: 'input',
        id: 'sourceId.equals',
        label: 'مبدا (انبار/مرکز)',
        icon: mdiWarehouse,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.equals',
        label: 'تاریخ تحویل ',
        icon: mdiCalendar,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت سفارش',
        icon: mdiStateMachine,
        data: [
          'ORDERED',
          'DELIVERED_TO_POST',
          'DELIVERED_TO_CENTER',
          'SUPPLIED_IN_CENTER',
          'PACKAGED',
          'BUNDLED',
          'LOADED',
          'ARRIVED',
          'DELIVERED',
          'NOT_DELIVERED',
          'RETURNED',
          'CANCELLED',
        ],
        translateType: 'Order',
      },
    ]);
  };

  const handleClose = () => {
    setOpenSize(false);
  };

  const handleClickAway = (e: any) => {
    // TODO: Shet
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenFilterBox(false);
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleFormSubmit = (values: driverInputs) => {
    setBundleInfo(values);
    setConfirmationDialog(true);
  };

  const getVehicles = async (type: string) => {
    try {
      const vehiclesRequest = new GetAllVehiclesRequestBuilder()
        .params({ 'klass.equals': type, size: 1000 })
        .build();
      const client = new Client(token);
      const { data } = await client.execute(vehiclesRequest);
      if (data) {
        props.getDriversDipatch({
          'vehicleId.in': data.map(el => el.id),
          size: 1000,
        });
      }
    } catch (err) {
      handleError(err.response);
    }
  };

  const handleChangeType = (value: string) => {
    getVehicles(value);
    secondSetValue('driverId', '');
    secondSetValue('driverName', '');
  };

  const handleSelectDriver = (value: string) => {
    secondSetValue('driverName', value);
    const selectedDriverItem = props.driverList.find(el => el.name === value);
    if (selectedDriverItem) {
      secondSetValue('driverPhone', selectedDriverItem.phoneNumber);
      secondSetValue('driverId', selectedDriverItem.id);
    }
  };

  const handleCreateBundle = async () => {
    try {
      const {
        deliveryDate,
        deliveryTime,
        driverId,
        driverName,
        vehicleType,
      } = bundleInfo!;
      setLoading(true);
      const payload = {
        deliveryDate,
        deliveryStartTime: convertPersianDigit2English(
          deliveryTime.substring(0, 2).concat(':00:00')
        ),
        deliveryEndTime: convertPersianDigit2English(
          deliveryTime.substring(3, 5).concat(':00:00')
        ),
        driverId,
        driverName,
        driverPhoneNumber: props.driverList.find(el => el.id === +driverId)
          ?.phoneNumber,
        orderCount: selectedList.length,
        priority: 0,
        status: 'CREATED',
        vehicleClass: vehicleType,
        vehicleId: props.driverList.find(el => el.id === +driverId)?.vehicleId,
        orderIds: selectedList.map(el => el.id),
      };
      const creatBundleRequest = new CreateBundleRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(creatBundleRequest);
      handleNotfication('مرسوله با موفقیت تخصیص یافت', 'success');
      setShowDragList(false);
      setSelectedList([]);
      setConfirmationDialog(false);
      setSelectDriver(false);
      getOrders();
      setupFilters();
      reset();
      props.clearDriverListDispatch();
    } catch (err) {
      handleError(err.response);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateBundleWithName = async () => {
    try {
      const {
        deliveryDate,
        deliveryTime,
        bundleName
      } = bundleInfo!;
      setLoading(true);
      const payload = {
        deliveryDate,
        deliveryStartTime: convertPersianDigit2English(
          deliveryTime.substring(0, 2).concat(':00:00')
        ),
        deliveryEndTime: convertPersianDigit2English(
          deliveryTime.substring(3, 5).concat(':00:00')
        ),
        orderCount: selectedList.length,
        priority: 0,
        status: 'CREATED',
        orderIds: selectedList.map(el => el.id),
        name: bundleName
      };
      const creatBundleRequest = new CreateBundleRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(creatBundleRequest);
      handleNotfication('مرسوله با موفقیت تخصیص یافت', 'success');
      setShowDragList(false);
      setSelectedList([]);
      setConfirmationDialog(false);
      setSelectDriver(false);
      getOrders();
      setupFilters();
      reset();
      props.clearDriverListDispatch();
    } catch (err) {
      handleError(err.response);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      <Grid container spacing={5}>
        <Grid container item xs={12} sm={6} alignItems="center">
          <Typography
            variant="h4"
            component="div"
            style={{ marginLeft: '20px', fontSize: '18px' }}
          >
            {`ایجاد مرسوله`}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.searchBox}>
            <form onSubmit={handleSubmit(onSubmit)} className={classes.input}>
              <IconButton
                type="submit"
                disabled={showDragList}
                className={classes.iconButton}
                aria-label="search"
              >
                <Icon
                  path={mdiMagnify}
                  size={1}
                  className={classes.magnifyIcon}
                />
              </IconButton>
              <InputBase
                disabled={showDragList}
                className={classes.input}
                name="id.equals"
                placeholder="شناسه سفارش"
                autoFocus
                inputRef={register({ required: !showDragList })}
              />
            </form>

            <ClickAwayListener onClickAway={handleClickAway}>
              <div>
                <Button
                  disabled={showDragList}
                  type="button"
                  onClick={handleClick}
                  className={classes.iconButton}
                  aria-label="search"
                >
                  {openFilterBox ? 'بستن' : 'جستجوی پیشرفته'}
                </Button>
                {openFilterBox ? (
                  <div
                    className={clsx(classes.filterBox, {
                      [classes.filterOpen]: openFilterBox,
                    })}
                  >
                    <RenderFilter
                      filters={filters}
                      onFilter={(filtervalues: any) => {
                        setFiltersValues({
                          ...removeEmptyValueObject(filtervalues),
                          deliveryType: { notEquals: 'POST' },
                          page: 0,
                          size: 10,
                        });
                        setOpenFilterBox(false);
                      }}
                      setOpenFilterBox={setOpenFilterBox}
                    />
                  </div>
                ) : null}
              </div>
            </ClickAwayListener>
          </div>
          {/* <Divider /> */}
        </Grid>
        <Grid container item xs={12} alignItems="center">
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} />
            {`بازگشت`}
          </Button>
        </Grid>

        <Grid xs={12} sm={6} item container alignItems="center">
          {props?.ordersList?.length > 0 && !showDragList && (
            <>
              <div className={classes.subtitle}>{`تعداد کل سفارش‌ها:`}</div>
              <div>
                &nbsp;
                <b>{`${props.count}`}</b>
              </div>
            </>
          )}
        </Grid>
        <Grid
          container
          item
          xs={12}
          md={6}
          direction="row-reverse"
          alignItems="center"
        >
          <div className={classes.btnBox}>
            {/*                 <Can
                  role={user.role}
                  perform="orders:downloadReportCSV"
                  yes={() => (
                    <>
                      <CSV
                        ordersDispatch={props.allOrdersDispatch}
                        data={props.allOrders}
                        filtersValues={filtersValues}
                        loading={props.loading}
                      />
                    </>
                  )}
                /> */}
          </div>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : showDragList ? (
            <OrderedList
              handleOpenSelectDriver={handleOpenSelectDriver}
              data={selectedList}
              loading={props.loading}
            />
          ) : (
            <React.Fragment>
              {props.ordersList.length > 0 ? (
                <List
                  handleSelectedList={handleSelectList}
                  handleSelectedItem={handleSelectItem}
                  handleSelectAllClick={handleSelectAllClick}
                  selectedList={selectedList}
                  filterVal={filtersValues}
                  loading={props.loading}
                  data={props.ordersList}
                />
              ) : (
                <Typography variant="h3" component="div">
                  سفارشی موجود نیست
                </Typography>
              )}
            </React.Fragment>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          {props.ordersList.length && !showDragList && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={handleClose}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={handleChangeSizePage}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {props.ordersList.length > 0 && !showDragList && (
            <Pagination
              className={classes.pagination}
              count={Math.ceil(props.count / filtersValues.size)}
              color="secondary"
              page={filtersValues.page + 1}
              onChange={handleChangePage}
            />
          )}
        </Grid>
        <Dialog
          open={selectDriver}
          fullWidth
          onClose={handleCloseSelectDriver}
          aria-labelledby="responsive-dialog-title"
        >
          <form onSubmit={handleSubmitHandler(handleFormSubmit)}>
            <DialogContent style={{ marginBottom: '16px' }}>
              <div
                style={{
                  position: 'absolute',
                  left: '17px',
                  zIndex: 10,
                }}
              >
                <IconButton
                  aria-label="close"
                  onClick={handleCloseSelectDriver}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              </div>
              <div className={classes.editIcon}>
                <Icon
                  path={mdiTruckDeliveryOutline}
                  size={4}
                  color={theme.palette.blue.main}
                />
              </div>
              <Grid container spacing={3}>
                {bundleType === 'driver' && (
                  <>
                    <Grid container item xs={12} alignItems="flex-end">
                      <div className={classes.item}>
                        <span className={classes.label}>
                          <Icon path={mdiCar} size={1} className={classes.icon} />
                          <InputLabel className={classes.label} id="vehicleType">
                            نوع خودرو
                          </InputLabel>
                        </span>
                        <span className={classes.inputHolder}>
                          <Controller
                            style={{ width: '100%', marginBottom: '8px' }}
                            name="vehicleType"
                            control={secondControl}
                            rules={{ required: true }}
                            render={({ onChange, value }) => (
                              <Select
                                value={value}
                                style={{ width: '100%' }}
                                onChange={e => {
                                  onChange(e);
                                  handleChangeType(e.target.value);
                                }}
                              >
                                <MenuItem value={'CAR'}>سواری</MenuItem>
                                <MenuItem value={'MOTORCYCLE'}>موتورسیکلت</MenuItem>
                                <MenuItem value={'PICKUPS'}>وانت</MenuItem>
                                <MenuItem value={'TRUCK'}>کامیون سبک</MenuItem>
                                <MenuItem value={'HEAVY_TRUCK'}>
                                  کامیون سنگین
                                </MenuItem>
                                <MenuItem value={'AIRPLANE'}>هواپیما</MenuItem>
                              </Select>
                            )}
                          />
                          <FormHelperText error focused>
                            {errors.vehicleType && 'نوع خودرو الزامی است'}
                          </FormHelperText>
                        </span>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={6} alignItems="flex-end">
                      <div className={classes.item}>
                        <span className={classes.label}>
                          <Icon
                            path={mdiMapMarkerCheckOutline}
                            size={1}
                            className={classes.icon}
                          />
                          <InputLabel className={classes.label} id="driverName">
                            نام راننده
                          </InputLabel>
                        </span>
                        <span className={classes.inputHolder}>
                          <Controller
                            style={{ width: '100%' }}
                            name="driverName"
                            control={secondControl}
                            rules={{ required: true }}
                            render={({ onChange }) => (
                              <Autocomplete
                                id="driverName"
                                noOptionsText="موردی یافت نشد"
                                disableClearable
                                onChange={(event: any, newValue: any | null) => {
                                  onChange(event);
                                  handleSelectDriver(newValue.name);
                                }}
                                getOptionSelected={(option, value) =>
                                  option.name === value.name
                                }
                                getOptionLabel={options => options.name}
                                options={
                                  props.driverList.length ? props.driverList : []
                                }
                                loading={props.driversLoading}
                                loadingText="در حال بارگذاری"
                                renderInput={params => (
                                  <TextField
                                    {...params}
                                    margin="normal"
                                    InputProps={{
                                      ...params.InputProps,
                                      type: 'search',
                                      endAdornment: (
                                        <React.Fragment>
                                          {props.driversLoading ? (
                                            <CircularProgress
                                              color="inherit"
                                              size={20}
                                            />
                                          ) : null}
                                          {params.InputProps.endAdornment}
                                        </React.Fragment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            )}
                          />
                          <FormHelperText error focused>
                            {errors.driverName && 'نام راننده الزامی است'}
                          </FormHelperText>
                        </span>
                      </div>
                    </Grid>
                    <Grid container item xs={12} sm={6} alignItems="flex-end">
                      <div className={classes.item}>
                        <span className={classes.label}>
                          <Icon
                            path={mdiKeyOutline}
                            size={1}
                            className={classes.icon}
                          />
                          <InputLabel className={classes.label} id="driverId">
                            شناسه راننده
                          </InputLabel>
                        </span>
                        <span className={classes.inputHolder}>
                          <Controller
                            style={{ width: '100%' }}
                            name="driverId"
                            control={secondControl}
                            disabled
                            as={<TextField type="text" />}
                          />
                        </span>
                      </div>
                    </Grid>
                  </>
                )}
                {bundleType === 'name' && (
                  <Grid container item xs={12} sm={12} alignItems="flex-end">
                    <div className={classes.item}>
                      <span className={classes.label}>
                        <Icon
                          path={mdiKeyOutline}
                          size={1}
                          className={classes.icon}
                        />
                        <InputLabel className={classes.label} id="driverId">
                          نام باندل
                        </InputLabel>
                      </span>
                      <span className={classes.inputHolder}>
                        <Controller
                          style={{ width: '100%' }}
                          name="bundleName"
                          control={secondControl}
                          as={<TextField type="text" />}
                        />
                      </span>
                    </div>
                  </Grid>
                )}
                <Grid container item xs={12} sm={6} alignItems="flex-end">
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCalendar}
                        size={1}
                        className={classes.icon}
                      />
                      <InputLabel className={classes.label} id="deliveryDate">
                        تاریخ تحویل
                      </InputLabel>
                    </span>
                    <span className={classes.inputHolder}>
                      <Controller
                        style={{ width: '100%' }}
                        name="deliveryDate"
                        control={secondControl}
                        rules={{ required: true }}
                        disabled
                        render={() => (
                          <MuiPickersUtilsProvider
                            utils={JalaliUtils}
                            locale="fa"
                          >
                            <DatePicker
                              fullWidth
                              autoOk
                              variant="inline"
                              format="YYYY/MM/DD"
                              // okLabel="تأیید"
                              disablePast
                              // cancelLabel="لغو"
                              // clearLabel="پاک کردن"
                              value={secondGetValue().deliveryDate}
                              labelFunc={date =>
                                date?.isValid()
                                  ? date.format('jYYYY/jMM/jDD')
                                  : ''
                              }
                              onChange={value => {
                                value &&
                                  secondSetValue(
                                    'deliveryDate',
                                    convertPersianDigit2English(
                                      value.format('YYYY-MM-DD')
                                    )
                                  );
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        )}
                      />
                      <FormHelperText error focused>
                        {secondError.deliveryDate && 'تاریخ تحویل الزامی میباشد'}
                      </FormHelperText>
                    </span>
                  </div>
                </Grid>
                <Grid container item xs={12} sm={6} alignItems="flex-end" >
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCalendar}
                        size={1}
                        className={classes.icon}
                      />
                      <InputLabel
                        className={classes.label}
                        id="deliveryStartTime"
                      >
                        ساعت آغار به کار
                      </InputLabel>
                    </span>
                    <span className={classes.inputHolder}>
                      <Controller
                        style={{ width: '100%' }}
                        name="deliveryTime"
                        control={secondControl}
                        rules={{ required: true }}
                        render={({ onChange, value }) => (
                          <Select
                            value={value}
                            style={{ width: '100%' }}
                            onChange={e => {
                              onChange(e)
                              e &&
                                secondSetValue(
                                  'deliveryTime',
                                  e.target.value
                                );
                            }}
                          >
                            <MenuItem value={'11-15'}>11-15</MenuItem>
                            <MenuItem value={'15-20'}>15-20</MenuItem>
                          </Select>
                        )}
                      />
                      <FormHelperText error focused>
                        {errors.deliveryStartTime &&
                          'ساعت آغاز به‌کار الزامی میباشد'}
                      </FormHelperText>
                    </span>
                  </div>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <Button
                    fullWidth
                    autoFocus
                    onClick={handleCloseSelectDriver}
                    variant="contained"
                    color="secondary"
                    size="large"
                  >
                    {`خیر`}
                  </Button>
                </Grid>
                <Grid item xs={4}>
                  <Button
                    fullWidth
                    disabled={loading}
                    type="submit"
                    variant="contained"
                    size="large"
                  >
                    {`بله`}
                  </Button>
                </Grid>
              </Grid>
            </DialogActions>
          </form>
        </Dialog>

        <Dialog
          open={confirmationDialog}
          fullWidth
          onClose={() => setConfirmationDialog(false)}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogContent>
            <div
              style={{
                position: 'absolute',
                left: '17px',
                zIndex: 10,
              }}
            >
              <IconButton
                aria-label="close"
                onClick={() => setConfirmationDialog(false)}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            </div>
            <div className={classes.editIcon}>
              <Icon
                path={mdiTruckDeliveryOutline}
                size={4}
                color={theme.palette.blue.main}
              />
            </div>
            <div>
              ایا از اختصاص مرسوله به {secondGetValue().driverName} مطمئن هستید؟
            </div>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={() => setConfirmationDialog(false)}
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  {`خیر`}
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  fullWidth
                  onClick={bundleType === 'driver' ? handleCreateBundle : handleCreateBundleWithName}
                  variant="contained"
                  size="large"
                >
                  {`بله`}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </Grid>
    </div>
  );
};

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  allOrders: makeSelectAllOrders(),
  count: makeSelectCountList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  driversLoading: makeDriverLoading(),
  driverList: makeSelectDriversList(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    ordersDispatch: (payload: Payload) => dispatch(getOrdersAction(payload)),
    allOrdersDispatch: (payload: Payload) =>
      dispatch(getAllOrdersReportAction(payload)),
    updateOrderStatusDispatch: (payload: {
      id: number;
      body: string;
      pagination: object;
    }) => dispatch(updateOrderStatusActions(payload)),
    updateAllOrderStatusDispatch: (payload: PayloadAllUpdate) =>
      dispatch(updateAllOrderStatusActions(payload)),
    cancelOrderDispatch: (payload: cancelPayload) =>
      dispatch(cancelOrderAction(payload)),
    changeDeliverTypeDispatch: (payload: PayloadChangeDeliveryType) =>
      dispatch(changeDeliveryTypeAction(payload)),
    getDriversDipatch: (payload: object) => dispatch(getDriversAction(payload)),
    clearDriverListDispatch: () => dispatch(cleanDriverListAction()),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(CreateBundle);
